import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from "react-redux";
import CustomCanvasV2 from "../../components/CustomCanvasV2";
import Cursor from "../../components/Cursor";
import Prev from "assets/svg/Prev";
import { useMeasure } from "react-use";
import { useNavigate } from "react-router-dom";
import StyledTooltip from "../../components/StyledTooltip";
import ArrowDown from "../../assets/svg/ArrowDown";
import FavoriteYes from "../../assets/svg/FavoriteYes";
import FavoriteNo from "../../assets/svg/FavoriteNo";
import { appCustomName, getConstantLayoutAll } from 'src/util/common';
import html2canvas from "html2canvas"; // ✅ html2canvas 추가
import Down from "../../assets/svg/Down";
import RemoteMinimize from "../../assets/svg/RemoteMinimize";
import RemoteMaximize from "../../assets/svg/RemoteMaximize";
import RemoteRestore from "../../assets/svg/RemoteRestore";
import RemoteClose from "../../assets/svg/RemoteClose";


import beApis from "../../util/apis/be";
import './index.css'
import { CardItem } from '../Home/SideCard/CardItem';
import DrawingButton from 'src/components/DrawingButton';
import IntlMessages from 'src/util/IntlMessages';
import StyledMenuOptions from 'src/components/StyledMenuOptions';

const FULLSCREEN_HANDLE = -1;
const FULLSCREEN_LABEL = '전체 화면';
const isFullscreenApp = (app) => app?.is_fullscreen || Number(app?.handle) === FULLSCREEN_HANDLE;

const Connected = ({ agentInfo, pcList, onQuickConnect, onCommand }) => {

  const navigate = useNavigate();
  const resolution = useSelector(({ webrtc }) => webrtc.resolution);
  const csSelected = useSelector(({ cs }) => cs.csSelected)

  const [containerRef, { width, height }] = useMeasure();

  const [mode, setMode] = useState({ pencil: false, eraser: false, pointer: false });
  const [enableDraw, setEnableDraw] = useState(false);
  const [initDraw, setInitDraw] = useState(false);
  const parentRef = useRef(null);
  const [color, setColor] = useState("red");
  const [lineWidth, setLineWidth] = useState(5);
  const [textSize, setTextSize] = useState(20);
  const [textColor, setTextColor] = useState("red");
  const [textWeight, setTextWeight] = useState('normal');
  const [textStyle, setTextStyle] = useState("");
  const [pointerColor, setPointerColor] = useState("red");
  const [annotationInfo, setAnnotationInfo] = useState({ type: "freeLine", color: "red" });
  const [w, setW] = useState(width)
  const [h, setH] = useState(height)
  const [deleteAll, setDeleteAll] = useState();
  const [capture, setCapture] = useState();

  const [favorites, setFavorites] = useState([]);

  const [isFavorite, setIsFavorite] = useState(false);

  const [openQuickConnect, setOpenQuickConnect] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const fullscreenApp = isFullscreenApp(agentInfo?.app);
  const appDisplayName = fullscreenApp ? FULLSCREEN_LABEL : appCustomName(agentInfo.app.title);
  const hideLocalCursor = fullscreenApp || mode.pointer;

  useEffect(() => {
    if (resolution.hasOwnProperty('width') && resolution.hasOwnProperty('height')) {
      const appRatio = resolution.height / resolution.width;
      const webRatio = height / width;

      if (appRatio < webRatio) {
        setW(width)
        setH(height * (appRatio / webRatio))
      } else {
        setW(width * (webRatio / appRatio))
        setH(height)
      }
    }
  }, [resolution, width, height]);

  useEffect(() => {
    if (mode.eraser || mode.text || mode.trash || mode.annotation) {
      setInitDraw(true);
      setEnableDraw(true);
    } else {
      setEnableDraw(false);
    }
    setOpenQuickConnect(false);
  }, [mode])

  useEffect(() => {
    setEnableDraw(false);
    setMode({})
    setInitDraw(false);
  }, [agentInfo])

  useEffect(() => {
    if (enableDraw) {
      setInitDraw(true);
    }
  }, [enableDraw])

  useEffect(() => {
    if (capture) {
      handleCapture();
    }
  }, [capture])

  const gotoPrev = () => {
    navigate(`/home`);
  }

  useEffect(() => {

    beApis.GetFavorites(csSelected.host).then(resp => {
      setFavorites(resp.favorites);
    })
  }, [])

  useEffect(() => {
    const find = favorites.find(item => item.device_access_token === agentInfo.device_access_token && item.product === agentInfo.app.title)
    if (find) {
      setIsFavorite(true)
    } else {
      setIsFavorite(false)
    }
  }, [favorites, agentInfo])

  const handleAddFavorite = () => {
    setOpenQuickConnect(false);

    const matched = favorites.find(item => item.device_access_token === agentInfo.device_access_token && item.product === agentInfo.app.title)
    const newFavorites = []
    if (matched) {
      favorites.map(item => {
        if (item.device_access_token === agentInfo.device_access_token && item.product === agentInfo.app.title) {

        } else {
          newFavorites.push(item)
        }
      })
    } else {
      favorites.map(item => {
        newFavorites.push(item)
      })
      newFavorites.push({
        device_access_token: agentInfo.device_access_token,
        product: agentInfo.app.title,
        at: new Date().getTime(),
      })
    }
    const values = {
      favorites: newFavorites,
    }
    beApis.UpdateFavorites(csSelected.host, values).then(resp => {
      beApis.GetFavorites(csSelected.host).then(resp => {
        setFavorites(resp.favorites);
      })
    })
  }

  const handleQuickConnect = (info) => {
    setOpenQuickConnect(false);
    onQuickConnect(info);
  }


  const menuOptions = pcList.map((item, idx) => {
    let groupName = ''
    if (item.groups) {
      const filtered = item.groups.filter(g => g.name !== getConstantLayoutAll())
      if (filtered.length > 0) {
        groupName = filtered[0].name
      }
    }

    const newItem = {
      ...item,
      name: item.custom_name,
      product: appCustomName(item.title),
      active: true,
      group_name: groupName,
    }
    return <div style={{ width: 250 }}>
      <CardItem showBtn={false} data={newItem} onClick={handleQuickConnect} key={"pcList" + idx} />
    </div>
  })

  function getFormattedTimestamp() {
    const now = new Date(); // 현재 지역 시간 기준
    const year = now.getFullYear();
    // getMonth()는 0부터 시작하므로 1을 더하고, padStart로 2자리 보장
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    // getDate()는 1부터 시작하므로 그대로 사용, padStart로 2자리 보장
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');

    return `${year}${month}${day}_${hours}${minutes}${seconds}`;
  }

  const handleCapture = async () => {
    if (!parentRef.current) return;
    const canvas = await html2canvas(parentRef.current, {
      backgroundColor: null, // ✅ 배경을 투명하게
      useCORS: true, // ✅ CORS 이미지 처리
    });

    // 📌 캡처한 내용을 이미지로 변환
    const imgData = canvas.toDataURL("image/png");
    const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, '');
    // 📌 이미지 다운로드 링크 생성
    const link = document.createElement("a");
    link.href = imgData;
    link.download = agentInfo.custom_name + "_" + appDisplayName + "_" + getFormattedTimestamp() + ".png";
    link.click();
  };

  const ellipsisStyle = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    lineHeight: "47px",
    position: "relative",
    width: "unset",
    maxWidth: 120,
  };

  const remoconMenuOptions = (
    <StyledMenuOptions
      options={[
        {
          key: 'minimize',
          icon: <RemoteMinimize />,
          label: <IntlMessages id="vlink.stream.manageRemoteWindow.minimize" />,
        },
        {
          key: 'restore',
          icon: <RemoteRestore />,
          label: <IntlMessages id="vlink.stream.manageRemoteWindow.restore" />
        },
        {
          key: 'maximize',
          icon: <RemoteMaximize />,
          label: <IntlMessages id="vlink.stream.manageRemoteWindow.maximize" />
        },

        {
          key: 'close',
          icon: <RemoteClose />,
          label: <IntlMessages id="vlink.stream.manageRemoteWindow.close" />
        }
      ]}
      onClick={(option) => {
        setOpenMenu(false);
        onCommand(option.key, agentInfo.app.handle)
      }}
    />
  );

  const onRemoteConClick = () => {
    setOpenMenu(!openMenu)

  }

  return (
    <div style={{
      flex: 1,
      background: '#4f4f4f',
      width: "100vw",
      height: "100vh",
      position: "absolute",
      top: 0,
      left: 0,
      // padding: 20,

    }}>
      <div className="stream-header">
        {/* 이전 버튼 */}
        <div style={{ flex: 1, display: "flex", flexDirection: "row", alignItems: "center" }}>
          <div
            style={{
              marginLeft: 4,
              // marginRight: 4,
              display: "flex",
              width: 50,
              height: 58,
              alignItems: 'center',
              justifyContent: 'center',
              cursor: "pointer",
            }}
            onClick={gotoPrev}
          >
            <Prev style={{ display: 'flex' }} />
          </div>
          <DrawingButton
            style={{
              display: "flex",
              width: 58,
              height: 58,
              alignItems: 'center',
              justifyContent: 'flex-start',
              cursor: "pointer",
              // backgroundColor: mode.pencil ? "#FFE9EF" : "#fff"
            }}
            onChangeMode={(option) => setMode(option)}
            onChangeColor={(color) => setColor(color)}
            onChangeLineWidth={(num) => setLineWidth(num)}
            mode={mode}
            color={color}
            lineWidth={lineWidth}
            textSize={textSize}
            textColor={textColor}
            textWeight={textWeight}
            textStyle={textStyle}
            onChangeTextSize={(num) => setTextSize(num)}
            onChangeTextColor={(color) => setTextColor(color)}
            onChangeTextWeight={(value) => { setTextWeight(value) }}
            onChangeTextStyle={(value) => { setTextStyle(value) }}
            onDeleteAll={() => setDeleteAll(`${new Date().getTime()}-${Math.random()}`)}
            onCapture={() => setCapture(`${new Date().getTime()}-${Math.random()}`)}
            pointerColor={pointerColor}
            onChangePointerColor={(value) => setPointerColor(value)}
            annotationInfo={annotationInfo}
            onChangeAnnotation={(info) => setAnnotationInfo(info)}
          />

        </div>


        <StyledTooltip content={menuOptions} open={openQuickConnect}>
          <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div style={{ margin: 10, height: "100%", display: "flex", cursor: "pointer" }} onClick={handleAddFavorite}>
              {isFavorite ? <FavoriteYes /> : <FavoriteNo />}
            </div>
            <div
              style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: 20 }}
              onClick={() => setOpenQuickConnect(!openQuickConnect)}>
              <div style={ellipsisStyle}>{agentInfo.custom_name}</div>
              <span style={{ margin: 3 }}>/</span>
              <div style={ellipsisStyle}>{appDisplayName}</div>
            </div>
            <div style={{ margin: 10, height: "100%", transform: "scale(0.8)", display: "flex" }}
              onClick={() => setOpenQuickConnect(!openQuickConnect)}>
              <ArrowDown style={{ cursor: "pointer" }} />
            </div>
          </div>
        </StyledTooltip>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', paddingRight: 20 }}>
          {!fullscreenApp && (
            <StyledTooltip content={remoconMenuOptions} open={openMenu} zIndex="99">
              <div
                style={{
                  minWidth: 49,
                  height: 48,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onClick={onRemoteConClick}
              >
                <IntlMessages id="vlink.stream.manageRemoteWindow" />
                <Down style={{ fontSize: "18px", marginLeft: 7 }} color={"#4F4F4F"} />
              </div>
            </StyledTooltip>
          )}
        </div>
      </div>

      <div style={{
        height: "calc(100% - 60px)",
        background: '#080101',
        overflow: "hidden",
      }}
        ref={containerRef}
      >
        <div className={'stream-contents' + (hideLocalCursor ? " cursor-none" : "")} ref={parentRef} id={'viewer-base'}>

          {mode.pointer && <Cursor parentRef={parentRef} color={pointerColor} />}
          <div className="video-wrapper">
            <video
              playsInline
              autoPlay
              className={'app-stream-video'}
              id='app-video'
              width={w}
              height={h}
            />
          </div>
          <div style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            display: enableDraw ? "flex" : "none",
            alignItems: "center",
            justifyContent: "center",

          }}>
            {initDraw &&
              <CustomCanvasV2
                type={mode}
                color={color}
                lineWidth={lineWidth}
                textSize={textSize}
                textColor={textColor}
                textWeight={textWeight}
                textStyle={textStyle}
                annotationInfo={annotationInfo}
                width={w}
                height={h}
                onClose={() => setMode({})}
                deleteAll={deleteAll}
              />}

          </div>

        </div>
        {enableDraw &&
          <div style={{
            position: "absolute", bottom: 5, left: "50%",
            transform: "translateX(-50%)", color: "#F13D6B",
            backgroundColor: "#181818",
            border: "1px solid #F13D6B", borderRadius: 3, padding: 10,
            userSelect: "none",
            display: "flex",
            alignItems: "center",
          }}>
            <span style={{ fontSize: 16 }}><IntlMessages id="vlink.stream.drawingActive" /></span>
            <div
              style={{
                cursor: "pointer",
                backgroundColor: "#F13D6B",
                border: "1px solid #F13D6B",
                borderRadius: 10,
                color: "#181818",
                fontSize: 12,
                padding: 5,
                marginLeft: 5
              }}
              onClick={(e) => { setMode({}) }}
            ><IntlMessages id="vlink.button.close" /></div>
          </div>
        }
      </div>
    </div>

  )
}


export default Connected;
